import { PropsWithChildren, useEffect } from 'react';

import {
  OnboardingContextActionType,
  OnboardingPayloadData,
  useOnboardingContext,
  useOnboardingDispatch
} from '@/contexts/onboardingContext';
import useMixpanel from '@/hooks/useTracking/useMixpanel';
import { useStepSubmit } from '@/pages/members/hooks/useStepSubmit';
import { StepProps } from '@/pages/members/pages/Onboarding/steps/types';

interface StepComponentProps extends Omit<StepProps, 'actionButtonText' | 'displayName'> {
  handleSubmit?: (callback: (data: OnboardingPayloadData) => void) => () => void;
  isValid?: boolean;
}

const StepComponent = ({
  children,
  handleSubmit,
  nodeType,
  uid,
  isValid = true
}: PropsWithChildren<StepComponentProps>) => {
  const onboardingContext = useOnboardingContext();
  const dispatch = useOnboardingDispatch();
  const mixpanel = useMixpanel();

  useEffect(() => {
    mixpanel.track('Screen Visited', {
      screenName: `onboarding:${nodeType}:${uid}`,
      version: onboardingContext.version,
      feature: 'unified-onboarding'
    });
  });

  useEffect(() => {
    dispatch({
      type: OnboardingContextActionType.SET_STEP_VALID,
      payload: isValid
    });
  }, [isValid, dispatch]);

  useStepSubmit({
    dispatch,
    handleSubmit,
    nodeType,
    uid
  });

  return children;
};

export default StepComponent;
